import {
    Component,
    ElementRef,
    ViewEncapsulation,
    Input,
    Output,
    EventEmitter,
    ViewChild,
} from '@angular/core';

@Component({
    selector: 'dialog-youtube',
    templateUrl: './dialog-youtube.component.html',
    styleUrls: ['./dialog-youtube.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class DialogYoutubeComponent {

    @ViewChild('youtubeframe', {static: true}) public youtubeframe: ElementRef;

    @Input()  public showComponent: boolean = false;

    @Output() public closeYoutubeEmmiter = new EventEmitter();

    public closeComponent() {
        this.closeYoutubeEmmiter.emit(false);
    }
}
